// ** Reducers Imports
import auth from "./authentication"
import client from "./client"
import layout from "./layout"
import navbar from "./navbar"

const rootReducer = {
  client,
  auth,
  navbar,
  layout
}

export default rootReducer
